(() => {
  const root = document.querySelector('[data-ltcg-article]');
  if (!root) return;
  const content = root.querySelector('[data-ltcg-content]');
  // TOC
  const toc = root.querySelector('[data-ltcg-toc]');
  const heads = content ? [...content.querySelectorAll('h2,h3')].filter((h) => h.textContent.trim()) : [];
  if (toc && heads.length >= 2) {
    const ol = toc.querySelector('ol'); const used = {};
    heads.forEach((h) => {
      if (!h.id) { let id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9äöüéèàç]+/g, '-').replace(/^-|-$/g, '') || 'section'; while (used[id]) id += '-2'; used[id] = 1; h.id = id; }
      const li = document.createElement('li'); li.className = h.tagName === 'H3' ? 'lv3' : 'lv2';
      const a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.append(a); ol.append(li);
    });
    toc.hidden = false;
    if (window.matchMedia('(max-width: 989px)').matches) toc.querySelector('details').open = false;
    const links = [...ol.querySelectorAll('a')];
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) links.forEach((l) => l.classList.toggle('is-on', l.hash === '#' + e.target.id)); }), { rootMargin: '-90px 0px -70% 0px' });
    heads.forEach((h) => io.observe(h));
  }
  // Lightbox
  const lb = document.querySelector('[data-ltcg-lightbox]');
  if (content && lb && lb.showModal) {
    content.querySelectorAll('img').forEach((img) => img.addEventListener('click', (e) => {
      if (img.closest('a')) e.preventDefault();
      // LTCG-FIXES r1: create the lightbox image on first open (no empty <img> in the HTML)
      let lbImg = lb.querySelector('img');
      if (!lbImg) { lbImg = document.createElement('img'); lb.append(lbImg); }
      lbImg.alt = img.alt; lbImg.src = img.currentSrc || img.src; lb.showModal();
    }));
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('[data-close]')) lb.close(); });
  }
  // Copy link
  root.querySelectorAll('[data-ltcg-copy]').forEach((b) => b.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(b.dataset.ltcgCopy); } catch (e) { window.prompt('', b.dataset.ltcgCopy); return; }
    const t = b.textContent; b.textContent = b.dataset.done || '✓'; setTimeout(() => (b.textContent = t), 2000);
  }));
  // Countdown
  root.querySelectorAll('[data-ltcg-count]').forEach((el) => {
    const target = new Date(el.dataset.ltcgCount.replace(' ', 'T')).getTime();
    if (isNaN(target)) { el.hidden = true; return; }
    const tick = () => {
      const d = target - Date.now();
      if (d <= 0) { el.querySelector('.ltcg-count__clock').hidden = true; el.querySelector('.ltcg-count__done').hidden = false; return; }
      el.querySelector('[data-d]').textContent = Math.floor(d / 864e5);
      el.querySelector('[data-h]').textContent = Math.floor(d / 36e5) % 24;
      el.querySelector('[data-m]').textContent = Math.floor(d / 6e4) % 60;
      setTimeout(tick, 30000);
    }; tick();
  });
  // Quick add (Horizon CartLinesUpdateEvent contract + drawer)
  const ids = () => [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((e) => e.dataset.sectionId))];
  root.querySelectorAll('[data-ltcg-add]').forEach((btn) => btn.addEventListener('click', async () => {
    btn.disabled = true;
    try {
      const sections = ids();
      const r = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(btn.dataset.ltcgAdd), quantity: 1, sections: sections.join(','), sections_url: location.pathname }) });
      const item = await r.json();
      if (!r.ok) throw new Error(item.description || item.message);
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const cart = await fetch((window.Theme?.routes?.cart_url || '/cart') + '.js', { credentials: 'same-origin' }).then((x) => x.json());
      const p = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(item.variant_id), quantity: 1 }], promise: p.promise }));
      p.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'ltcg-blog', sourceId: 'ltcg-blog', itemCount: 1, productId: String(item.product_id), sections: item.sections, didError: false } });
      document.dispatchEvent(new CustomEvent('ltcg:cart-changed', { detail: { cart, productId: item.product_id } }));
      const d = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
      await new Promise((res) => requestAnimationFrame(res));
      if (d && !d.isOpen && typeof d.open === 'function') d.open(); else if (!d) location.href = '/cart';
    } catch (e) { console.warn('[LTCG blog] add', e); alert(e.message || 'Error'); }
    btn.disabled = false;
  }));
})();
